module.exports = __webpack_public_path__ + "static/img/labour-love.0327d70.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/labour-love.svg
// module id = vxaW
// module chunks = 1